import { render } from "./Institutions.vue?vue&type=template&id=a45206b6&scoped=true"
import script from "./Institutions.vue?vue&type=script&lang=js"
export * from "./Institutions.vue?vue&type=script&lang=js"

import "./Institutions.vue?vue&type=style&index=0&id=a45206b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45206b6"]])

export default __exports__